import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/services/encryption.service';
import { UtilisateursService } from 'src/app/services/utilisateurs.service';
import { CustomValidators } from '../dialogue-user/custom-validators';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {

  formGroup : FormGroup;
  user : any;

  constructor(private fb:FormBuilder, private userService:UtilisateursService,private encryptService:EncryptionService) { }

  ngOnInit(): void {
    this.user =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));

    this.formGroup = this.fb.group({
        actualPassword : [null, Validators.required],
        newPassword: [null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(8)
          ])
        ],
        confirmPassword: [null, Validators.compose([Validators.required])]
      }, {
        validators : this.mustMatch('newPassword', 'confirmPassword')
      });

  }


  /**
   * VALIDATION
   */
  createSignupForm(): FormGroup {
    return this.fb.group(
      {
        actualPassword : [null,null],
        newPassword: [null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(8)
          ])
        ],
        confirmPassword: [null, Validators.compose([Validators.required])]
      },
      {
        // check whether our password and confirm password match
        validator: CustomValidators.passwordMatchValidator
      }
    );
  }

  submitChange() {
    console.log(this.formGroup.value);

    let actualPass = this.formGroup.value.actualPassword;
    let newPass = this.formGroup.value.newPassword;
    let matricule = this.user['matricule'];

    this.userService.updatePassword(matricule,actualPass,newPass).subscribe(value => {
    
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);

        if(value['cause'] === "Mdp non valide") {
          alert('Mot de passe incorrect');
        }
      }else {
        alert('Mot de passe changé avec succès');
      }
    });
    
  }

  f() { return this.formGroup.controls};


  mustMatch(controlName:string, matchingControlName:string) {
    return (fG: FormGroup) => {
        const control = fG.controls[controlName];
        const matchingControl = fG.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
  }

  disableButton() {
    if(this.f().actualPassword.errors || this.f().newPassword.errors || this.f().confirmPassword.errors) {
      return true;
    } else {
      return false;
    }
  }
}
